import { createSlice } from "@reduxjs/toolkit";
import { MoveDirection } from "components/workspaces/left-pane/types";
const initialState = {};
const slice = createSlice({
    initialState,
    name: "LeftPaneReducers",
    reducers: {
        reorderExpandedPanels: (state, action) => {
            const { leftPaneId, currentExpanded, currentPanelId, nextExpanded, nextPanelId, previousExpanded, previousPanelId, direction } = action.payload;
            if (direction === MoveDirection.Down) {
                state[leftPaneId] = { ...state[leftPaneId],
                    expandedPanels: { ...state[leftPaneId]?.expandedPanels ?? {},
                        [nextPanelId]: currentExpanded,
                        [currentPanelId]: nextExpanded } };
            }
            else {
                state[leftPaneId] = { ...state[leftPaneId],
                    expandedPanels: { ...state[leftPaneId]?.expandedPanels ?? {},
                        [previousPanelId]: currentExpanded,
                        [currentPanelId]: previousExpanded } };
            }
        },
        setIsLeftPaneOpen: (state, action) => {
            const { leftPaneId, isOpen } = action.payload;
            state[leftPaneId] = { ...state[leftPaneId], isOpen };
        },
        setPanelExpanded: (state, action) => {
            const { leftPaneId, expanded, panelId } = action.payload;
            state[leftPaneId] = { ...state[leftPaneId], expandedPanels: { ...state[leftPaneId]?.expandedPanels ?? {}, [panelId]: expanded } };
        }
    }
});
export const leftPaneReducers = slice.reducer;
export const { setIsLeftPaneOpen, setPanelExpanded, reorderExpandedPanels } = slice.actions;
